import * as runtypes from 'runtypes';
import * as institution from 'src/models/institution';

export const InstitutionRecord = runtypes.Dictionary(institution.types.Institution, runtypes.String);

export type InstitutionRecord = runtypes.Static<typeof InstitutionRecord>;
